<template>
  <form @keyup.esc="close()" tabindex="0" >
  <v-layout id='favorite_view' class='favorite-view' v-resize="onResize" v-if="mapData.favoriteView.show" :style="{'left': left, 'top': top}" >
    <div class="view-wrap">
      <v-layout class="view-title-bar" v-on:mousedown="dragStart" align-center justify-space-between row shrink>
        <v-flex class="text-xs-left hidden-md-and-up" shrink>
          <v-btn fit icon @click="close()"><v-icon>keyboard_arrow_left</v-icon></v-btn>
        </v-flex>
        <v-flex :class="['text-xs-left', 'title-text', ($vuetify.breakpoint.mdAndUp) ? 'pl-4' : 'pl-1']">
          찜한매물
        </v-flex>
        <v-flex class="text-xs-right hidden-sm-and-down mr-1" shrink>
          <v-btn fit icon @click="close()"><v-icon>close</v-icon></v-btn>
        </v-flex>
      </v-layout>
      <div class="view-list">
        <div class="list-wrap">
          <!-- 리스트 시작-->
          <div class="list-tot-count" >
            찜한매물개수 <span class="num">{{mapData.favoriteList.length}}</span>개
          </div>
          <div id="favorite_list" class="favorite-list">
            <div v-if="mapData.favoriteView.data.length > 0" v-for="(item, i) in mapData.favoriteView.data" :key="i">
              <v-layout class="list-item">
                <v-flex shrink class="title-img">
                  <!-- 매물 플로트 정보 -->
                  <div>
                    <div class="favorite" @click="toggleFavorite(item.no)">
                      <v-icon v-if="isFavorite(item.no)" class="active">favorite</v-icon>
                      <v-icon v-if="!isFavorite(item.no)">favorite_border</v-icon>
                    </div>
                    <v-layout class="img-tag-line">
                      <v-flex class="tag" v-if="item.img2dCount > 0">#2D</v-flex>
                      <v-flex class="tag" v-if="item.img3dCount > 0">#3D</v-flex>
                      <v-flex class="tag" v-if="item.imgVRCount > 0">#VR</v-flex>
                    </v-layout>
                  </div>
                  <router-link :to="{ path: 'map', query: { no: 'r' + item.no }}">
                    <img v-if="item.imgurl !== ''" :src="item.imgurl"/>
                    <div v-if="item.imgurl === ''" class="no-img"><v-icon>camera_alt</v-icon> 촬영준비중</div>
                  </router-link>
                </v-flex>
                <!-- 매물 -->
                <v-flex glow class="list-info">
                  <router-link :to="{ path: 'map', query: { no: 'r' + item.no }}">
                    <div class="price-line">{{item.price}}</div>
                    <div class="addr-line">{{item.addr}}</div>
                    <div class="info-line"><span class="mr-2">{{item.struct}}</span><span class="point mr-2">{{item.itemtype}}</span></div>
                    <div class="info-line"><span class="mr-2">{{item.floor}}</span><span>관리비 {{item.mcost}}</span></div>
                    <div class="tag-line">
                        <span v-if="item.tag.length > 0 && tag !== '' && index <= 2" v-for="(tag, index) in item.tag" :key="tag" class="tag">
                          #{{tag}}
                        </span>
                    </div>
                  </router-link>
                </v-flex>
              </v-layout>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-layout>
  </form>
</template>

<script>
// import EventBus from '@/utile/eventBus'
import Utile from '@/utile/utile'
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  name: 'FavoriteView',
  data: () => ({
    // 뷰
    drag: false,
    viewElement: null,
    currentX: 0,
    currentY: 0,
    initialX: 0,
    initialY: 0,
    xOffset: 0,
    yOffset: 0,
    top: 0,
    left: 0,
    isMobile: Utile.isMobile()
  }),
  components: {
  },
  computed: {
    ...mapState({
      mapData: state => state.mapData,
      auth: state => state.auth
    }),
    ...mapGetters({
      isFavorite: 'mapData/isFavorite'
    })
  },
  watch: {
    '$route' (to, from) {
      if (this.mapData.favoriteView.show) { // 페이지 이동시 클로즈
        this.mapData.favoriteView.show = false
      }
    }
  },
  mounted () {
    this.loadFavoriteList()
  },
  methods: {
    ...mapActions({
      requestMapData: 'mapData/requestMapData',
      toggleFavorite: 'mapData/toggleFavorite',
      loadFavoriteList: 'mapData/loadFavoriteList'
    }),
    showModifView (type, url) {
      this.mapData.modifView.type = type
      this.mapData.modifView.src = url
      this.mapData.modifView.show = true
    },
    getStaticUrl () {
      return Utile.getStaticUrl()
    },
    close () {
      // this.$router.replace('map')
      this.mapData.favoriteView.show = false
    },
    dragStart (e) {
      if (!Utile.isMobile()) {
        this.drag = true
        this.viewElement = document.getElementById('favorite_view')
        this.initialX = e.clientX - this.xOffset
        this.initialY = e.clientY - this.yOffset
        window.addEventListener('mousemove', this.dragging, false)
        window.addEventListener('mouseup', this.dragEnd, false)
      }
    },
    dragEnd (e) {
      if (!Utile.isMobile()) {
        this.drag = false
        window.removeEventListener('mousemove', this.dragging, false)
        window.removeEventListener('mouseup', this.dragEnd, false)
      }
    },
    dragging (e) {
      if (this.drag) {
        this.currentX = e.clientX - this.initialX
        this.currentY = e.clientY - this.initialY

        this.xOffset = this.currentX
        this.yOffset = this.currentY
        // this.viewElement.style.transform = `translate(${this.currentX}px, ${this.currentY}px)`
        this.top = this.currentY + 'px'
        this.left = this.currentX + 'px'
      }
    },
    onResize () {
      if (document.getElementById('favorite_view') != null) {
        if (this.top === 0) {
          let top = (window.innerHeight / 2) - (document.getElementById('favorite_view').clientHeight / 2)
          let left = (window.innerWidth / 2)
          this.top = top + 'px'
          this.left = left + 'px'
          this.xOffset = left
          this.yOffset = top
        }
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/modal/FavoriteView.vue